import { motion } from "framer-motion";
import { STEPS, ASSETS } from "@/data";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export default function Steps() {
  return (
    <section id="steps" data-testid="steps-section" className="py-20 md:py-32 bg-foreground text-white overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-7">
            <div className="font-mono-accent text-xs uppercase tracking-[0.2em] text-accent mb-4">// Η Πορεία προς την Επιτυχία</div>
            <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-tight">
              Τα όνειρά σου ξεκινούν εδώ.
              <span className="block text-white/50">…και γίνονται πραγματικότητα.</span>
            </h2>

            <div className="mt-10 space-y-px">
              {STEPS.map((s, i) => (
                <motion.div
                  key={s.n}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: i * 0.06 }}
                  data-testid={`step-${s.n}`}
                  className="group flex items-center gap-5 border-b border-white/10 py-4 hover:bg-white/5 transition-colors px-2"
                  style={{ marginLeft: `${i * 8}px` }}
                >
                  <span className="font-mono-accent text-sm text-accent w-8">{s.n}</span>
                  <s.icon className="h-6 w-6 text-white/70 group-hover:text-accent transition-colors shrink-0" strokeWidth={1.5} />
                  <span className="font-heading font-bold text-lg sm:text-xl uppercase tracking-tight">{s.title}</span>
                </motion.div>
              ))}
            </div>

            <button
              data-testid="steps-cta"
              onClick={() => scrollTo("enroll")}
              className="mt-10 inline-flex items-center gap-2 bg-accent text-white font-mono-accent text-sm uppercase tracking-widest px-8 py-4 rounded-sm hover:bg-white hover:text-foreground transition-colors"
            >
              Ξεκίνα την πορεία σου
            </button>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-5"
          >
            <div className="relative">
              <div className="absolute -top-4 -right-4 h-full w-full border border-accent/40 rounded-sm" />
              <img
                data-testid="poster-image"
                src={ASSETS.poster}
                alt="Αφίσα Φυσική Επιλογή — Εγγραφές 2026-2027"
                className="relative w-full rounded-sm shadow-2xl"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
